/*
 * The last built feed, kept on the device so /feed (and the home preview)
 * can show it at once while the fresh one is built (useFeed.js).
 *
 * - Tied to the account: a feed saved for one uid is never shown to
 *   another, and signing out deletes it (UserLogout.js, App.jsx).
 * - Items past their end (`until`, set by the server provider; events
 *   included) are dropped when it's read; a save older than MAX_AGE is
 *   ignored.
 */
const KEY = 'baws_feed_cache_v1';
const MAX_AGE = 3 * 24 * 60 * 60 * 1000;

export function loadSavedFeed(uid, now = Date.now()) {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!saved || saved.v !== 1 || now - saved.at > MAX_AGE) return null;
    if ((saved.uid || null) !== (uid || null)) return null;
    const items = saved.items.filter(
      (it) => it.until == null || now < it.until
    );
    if (!items.length) return null;
    const present = new Set(items.map((it) => it.source));
    return {
      items,
      sources: saved.sources.filter((s) => present.has(s.id)),
      loading: false,
      saved: true, // shown from the device; a fresh build is on its way
    };
  } catch (e) {
    return null;
  }
}

export function saveFeed(uid, { items, sources }) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ v: 1, uid: uid || null, at: Date.now(), items, sources })
    );
  } catch (e) {
    // full or blocked storage: the feed still works, just not instantly
  }
}

export function clearSavedFeed() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
}
